// extracted by mini-css-extract-plugin
module.exports = {"scopeList":"ScopesTooltip_scopeList__8yU3k","scopeTooltip":"ScopesTooltip_scopeTooltip___TLsj"};